import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { ErrorState } from '@/shared/ui/feedback/ErrorState';
import { extractErrorMessage } from '@/shared/api/errors';
import { formatDateTime } from '@/shared/utils/date';
import { useLimitConfig } from '@/entities/limit-config';
import { FeaturesLimitConfigLimitConfigForm } from '@/features/limit-config';

export const WidgetsLimitConfigMain = () => {
  const { t } = useTranslation();
  const query = useLimitConfig();

  return (
    <>
      <PageHeader title={t('limitConfig.title')} subtitle={t('limitConfig.subtitle')} />
      <div className="mx-auto w-full max-w-3xl space-y-4 px-4 py-4 lg:px-6 lg:py-6">
        {query.isLoading ? (
          <div className="flex justify-center py-16">
            <Spinner />
          </div>
        ) : query.error ? (
          <ErrorState
            message={extractErrorMessage(query.error, t('limitConfig.loadError'))}
            onRetry={() => void query.refetch()}
          />
        ) : query.data ? (
          <>
            <FeaturesLimitConfigLimitConfigForm config={query.data} />
            <p className="text-right text-xs text-ink-muted">
              {t('limitConfig.updatedAt', { date: formatDateTime(query.data.updated_at) })}
            </p>
          </>
        ) : null}
      </div>
    </>
  );
};
